import React from 'react';
import { MdToggleOn, MdToggleOff } from 'react-icons/md';

function StatusToggle({ isActive, onToggle, disabled, id, activeLabel, inactiveLabel }) {
  const handleClick = () => {
    if (disabled) return;
    onToggle(!isActive);
  };

  return (
    <button
      id={id}
      type="button"
      className={`status-toggle-icon ${isActive ? 'active' : 'inactive'}${disabled ? ' disabled' : ''}`}
      onClick={handleClick}
      aria-pressed={isActive}
      title={isActive ? (activeLabel || 'Active') : (inactiveLabel || 'Inactive')}
      style={{
        background: 'transparent',
        border: 'none',
        cursor: disabled ? 'not-allowed' : 'pointer',
        padding: '4px',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        fontSize: '1.5rem',
        opacity: disabled ? 0.5 : 1,
      }}
    >
      {isActive ? (
        <MdToggleOn style={{ color: '#10b981', fontSize: '2rem' }} />
      ) : (
        <MdToggleOff style={{ color: '#6b7280', fontSize: '2rem' }} />
      )}
      {(activeLabel || inactiveLabel) && (
        <span style={{
          fontSize: '0.875rem',
          fontWeight: 600,
          color: isActive ? '#10b981' : '#6b7280'
        }}>
          {isActive ? (activeLabel || 'Active') : (inactiveLabel || 'Inactive')}
        </span>
      )}
    </button>
  );
}

export default StatusToggle;


